import { apiGet } from "./apiClient";

const IMAGE_SOURCE_FIELDS = ["url", "data", "path", "src", "image_url", "imageUrl", "file_url", "fileUrl", "filePath", "file_name", "fileName"];
export function normalizeTaskImages(value) {
  if (!Array.isArray(value)) return [];
  return value.map(entry => {
    if (typeof entry === "string") return entry.trim();
    if (!entry || typeof entry !== "object") return "";
    const source = IMAGE_SOURCE_FIELDS.map(key => entry[key]).find(candidate => typeof candidate === "string" && candidate.trim());
    return source?.trim() || "";
  }).filter(Boolean);
}

// The single most cross-domain-reused fetch in the feature — the same GET,
// independently re-implemented in WorkflowTaskDrawer, CancelModal,
// EditDraftDrawer, SendToSuppliersModal, QuoteApprovalModal, and PriceUpdateDrawer.
// Commercial task details are separate from the Payments V2 projection.
// The authenticated token is the only actor identity. Ownership and
// cross-owner visibility are enforced by the backend permission layer.
export function fetchTaskDetail(queryPk) {
  const qs = new URLSearchParams({ query_pk: queryPk });
  return apiGet(`/query_workflow/task/get?${qs}`).then(res => {
    if (!res.data?.success) throw new Error(res.data?.message || "Failed to load task details");
    const data = res.data.data ?? null;
    if (!data?.task || !Object.prototype.hasOwnProperty.call(data.task, "images")) return data;
    return { ...data, task: { ...data.task, images: normalizeTaskImages(data.task.images) } };
  });
}
